module.exports = __webpack_public_path__ + "static/media/delete.2162f90f.svg";